import { render, staticRenderFns } from "./LsSelectOrg.vue?vue&type=template&id=49521e67&scoped=true"
import script from "./LsSelectOrg.vue?vue&type=script&lang=js"
export * from "./LsSelectOrg.vue?vue&type=script&lang=js"
import style0 from "./LsSelectOrg.vue?vue&type=style&index=0&id=49521e67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49521e67",
  null
  
)

export default component.exports